<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('stockClose.reOpen') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('stockClose.remarks')
              }}</label>
              <div>
                <textarea
                  rows="3"
                  ref="remarks"
                  class="form-control"
                  v-model="model.remarks"
                  :class="{ 'is-invalid': errors.has('remarks') }"
                  autofocus
                ></textarea>
                <div class="invalid-feedback" v-if="errors.has('remarks')">
                  {{ errors.first('remarks') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="reOpen"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['reocrd'],
  name: 'student-profile-delete-form',
  data () {
    return {
      model: {
        cycle_id: '',
        remarks: ''
      },
      errors: new Errors(),
      saving: false
    }
  },
  mounted () {
    this.$refs.remarks.focus()
  },
  created () {
    this.model.cycle_id = this.reocrd.cycle_id
  },
  methods: {
    reOpen () {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('stock/stockClose/reOpen', this.model)
        .then(response => {
          return this.$store.dispatch('stock/stockClose/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
